module.exports = __webpack_public_path__ + "img/logo_bucuresti_2050_text_fara-subtitlu_bicrom_linie.8cb564e3.svg";